export const GET_GROUPS = "GET_GROUPS";
export const GET_LIBRARIES_FROM_GROUPS = "GET_LIBRARIES_FROM_GROUPS";
export const GET_GROUP_ID = "GET_GROUP_ID";
export const GET_GROUP_DELETED = "GET_GROUP_DELETED";
export const GET_GROUP_DELETED_ID = "GET_GROUP_DELETED_ID";